import { Button } from "@mui/material";
import { useSnackbar } from "notistack"
import { useDispatch } from "react-redux";
import { resetSavedAlbums } from "../../actions/albumListActions";

const SnackbarRefreshSavedAlbumsButton = ({snackbarKey}) => {
    const { closeSnackbar } = useSnackbar();
    const dispatch = useDispatch();
    
    const onClick = () => {
        dispatch(resetSavedAlbums());
        closeSnackbar(snackbarKey);
    }

    return (
        <Button onClick={onClick} color="default">
            Refresh
        </Button>
    )
}

export default SnackbarRefreshSavedAlbumsButton;